<app-header
    style="width: 100%"
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchedLanguage($event)"
>
</app-header>

<section
    class="sme-new-app tw-pb-[45px] tw-bg-gradient-to-b tw-from-[#FFFBF8] tw-to-[30%] tw-to-[#F9F9F9]"
    (click)="closeMegaMenuCondition()"
>
    <div
        [ngClass]="noMatchedProducts ? 'tw-pt-[20px]' : ''"
        class="sme-container"
    >
        <app-application-stepper
            *ngIf="!noMatchedProducts"
            [value]="value"
        ></app-application-stepper>
        <app-application-stepper
            *ngIf="isBRPNoMatchFlow || isCIDBNoMatchFlow"
            [value]="35"
        ></app-application-stepper>
        <mat-divider
            *ngIf="!noMatchedProducts || isBRPNoMatchFlow || isCIDBNoMatchFlow"
        ></mat-divider>
        <section class="tw-max-w-[920px] tw-mx-auto">
            <ng-container *ngIf="isCGCFlow">
                <h2
                    class="!tw-mb-1 !tw-text-[20px]"
                    *ngIf="!noMatchedProducts && apiResponse"
                >
                    {{ initialMatchedProdTotal }}
                    <ng-container
                        *ngIf="
                            initialMatchedProdTotal == 1;
                            else multipleProducts
                        "
                    >
                        {{ "PRODUCT_MATCHING.MATCHED_PRODUCT$" | translate }}
                    </ng-container>
                    <ng-template #multipleProducts>
                        {{ "PRODUCT_MATCHING.MATCHED_PRODUCTS$" | translate }}
                    </ng-template>
                </h2>
                <h2
                    *ngIf="noMatchedProducts && !noAvailableOptions"
                    class="!tw-mb-1 !tw-text-[20px] sm:!tw-text-[25px] !tw-leading-[1.5] tw-pt-3"
                    [innerHTML]="'PRODUCT_MATCHING.NO_MATCH' | translate"
                ></h2>
                <h2
                    *ngIf="noMatchedProducts && noAvailableOptions"
                    class="!tw-mb-1 !tw-text-[20px] sm:!tw-text-[25px] !tw-leading-[1.5] tw-pt-3"
                    [innerHTML]="'PRODUCT_MATCHING.NO_AVAILABLE_OPTIONS' | translate"
                ></h2>
                <span class="tw-text-gray-600 tw-text-[14px]" *ngIf="!noAvailableOptions">
                    {{
                        noMatchedProducts
                            ? ("PRODUCT_MATCHING.IMPORTANT_NOTE_NO_MATCHED"
                              | translate)
                            : ("PRODUCT_MATCHING.IMPORTANT_NOTE_MATCHED"
                              | translate)
                    }}
                </span>
                <app-product-selection-tab
                    *ngIf="!noAvailableOptions"
                    [isP2POnly]="noMatchedProducts"
                    [P2P_ProductsTotal]="P2P_ProductsTotal"
                    [bankProductsTotal]="bankProductsTotal"
                    [DigitalBanks_ProductsTotal]="DigitalBanks_ProductsTotal"
                ></app-product-selection-tab>
                <mat-divider
                    [ngClass]="noMatchedProducts ? '!tw-my-[5%]' : ''"
                ></mat-divider>
                <h2
                    class="!tw-text-[18px] md:!tw-text-[20px]"
                    *ngIf="!noMatchedProducts && !noAvailableOptions"
                >
                    {{ "PRODUCT_MATCHING.RECOM_PRODUCTS" | translate }}
                </h2>
                <div
                    *ngIf="
                        matchedProductsTotal > 0 ||
                        p2pProducts.length > 0 
                    "
                    id="recommended-products"
                    class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-my-5"
                >
                    <ng-container
                        *ngFor="
                            let productDetails of noMatchedProducts
                                ? p2pProducts
                                : recomProdList;
                            let i = index
                        "
                    >
                        <app-product-card
                            *ngFor="
                                let item of productDetails?.prodNameList;
                                let j = index
                            "
                            [product]="item"
                            [index]="i"
                            [isRecomm]="isRecommended"
                            [isSelected]="
                                prodArr?.includes(item.prodCode) ?? false
                            "
                            [selectedBranch]="branchArray"
                            [isDisabled]="noMatchedProducts && fASelected"
                            [faSelected]="fASelected"
                            [limitExceeded]="limitExceeded"
                            [productDetails]="productDetails"
                            [selectedLanguage]="selectedLanguage"
                            [isBRP_CGC_Flow]="isBRP_CGC_Flow"
                            [isP2POnly]="noMatchedProducts"
                            (showDialog)="showDialog($event)"
                            (recommendedProductSelect)="
                                noMatchedProducts
                                    ? onSelectNoMatchedProd($event)
                                    : recommendedProductSelect($event)
                            "
                            [changeBranch]="handleChangeBranch(productDetails)"
                        ></app-product-card
                    ></ng-container>
                </div>
                <div
                    *ngIf="
                        recomDigitalBankList.length > 0
                    "
                    id="recommended-digital-bank-products"
                    class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-my-5"
                >
                    <ng-container
                        *ngFor="
                            let productDetails of recomDigitalBankList;
                            let i = index
                        "
                    >
                        <app-product-card
                            *ngFor="
                                let item of productDetails?.prodNameList;
                                let j = index
                            "
                            [product]="item"
                            [index]="i"
                            [isRecomm]="isRecommended"
                            [isSelected]="
                                prodArr?.includes(item.prodCode) ?? false
                            "
                            [selectedBranch]="branchArray"
                            [isDisabled]="noMatchedProducts && fASelected"
                            [faSelected]="fASelected"
                            [limitExceeded]="limitExceeded"
                            [productDetails]="productDetails"
                            [selectedLanguage]="selectedLanguage"
                            [isBRP_CGC_Flow]="isBRP_CGC_Flow"
                            [isP2POnly]="noMatchedProducts"
                            (showDialog)="showDialog($event)"
                            (recommendedProductSelect)="
                                noMatchedProducts
                                    ? onSelectNoMatchedProd($event)
                                    : recommendedProductSelect($event)
                            "
                            [changeBranch]="handleChangeBranch(productDetails)"
                        ></app-product-card
                    ></ng-container>
                </div>
            </ng-container>
        </section>
        <app-no-match-financial-advisory
            *ngIf="noMatchedProducts && isCGCFlow"
            [isDisabled]="selectedProducts.length > 0"
            (fASelect)="onSelectFA($event)"
            [isSelected]="fASelected"
        ></app-no-match-financial-advisory>
        <!--DESKTOP-->
        <div
            class="tw-hidden md:tw-flex tw-flex-col tw-items-start tw-gap-[10px]"
        >
            <div class="tw-flex tw-flex-col tw-gap-[10px]">
                <span
                    class="tw-font-bold tw-text-[#7B7575] tw-text-lg"
                    *ngIf="productName"
                >
                    {{ "PRODUCT_MATCHING.YOU_ARE_APPLYING_FOR" | translate }}:
                </span>
                <div
                    class="tw-bg-[#E3E8EC] tw-w-auto tw-text-center tw-p-[16px] tw-rounded-[16px]"
                    *ngIf="productName"
                >
                    <span
                        class="md:tw-text-2xl tw-font-semibold tw-text-[#003A70]"
                    >
                        {{ productName }}
                    </span>
                </div>
            </div>
        </div>
        <!--DESKTOP-->
        <!--MOBILE-->
        <div
            *ngIf="matchedProductsTotal > 0"
            class="tw-flex xl:tw-hidden tw-grid tw-items-center tw-grid-cols-1 xl:tw-grid-cols-[calc(100%_-_310px),300px] tw-gap-[10px] tw-pt-[40px] tw-pb-[20px] md:tw-pt-[10px] md:tw-pb-[10px] tw-mx-0 md:tw-mx-[80px] xl:tw-mx-0 tw-mt-3"
        >
            <div class="tw-flex tw-flex-col tw-gap-[12px]">
                <mat-card
                    class="cardCSS"
                    appearance="outlined"
                    *ngIf="productName"
                >
                    <mat-card-content>
                        <div class="tw-flex tw-flex-col tw-gap-[15px]">
                            <div
                                class="tw-font-[500] tw-text-[#6B6B6B] tw-text-[16px] tw-text-center"
                            >
                                {{
                                    "NEW_APPLICATION.YOU_ARE_APPLYING_FOR"
                                        | translate
                                }}
                            </div>
                            <div
                                class="tw-bg-[#E3E8EC] tw-p-[16px] tw-rounded-[16px] tw-text-center"
                            >
                                <span
                                    class="tw-text-[14px] tw-leading-[16.8px] tw-font-[700] tw-text-[#003A70]"
                                >
                                    {{ productName }}
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <!--MOBILE-->

        <div
            class="tw-text-2xl tw-font-semibold {{
                matchedProductsTotal ? 'tw-border-opacity-10' : ''
            }}"
        >
            <ng-container *ngIf="!noMatchedProducts && !noAvailableOptions">
                <div
                    #noProductsOnFilter
                    class="tw-flex tw-justify-between tw-items-center tw-text-[18px] tw-mt-[20px] tw-mb-[12px] tw-max-w-[920px] tw-mx-auto"
                >
                    <div
                        class="tw-flex tw-items-start tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-[10px] md:tw-gap-[28px]"
                    >
                        {{
                            (matchedProductsList?.length == 1
                                ? "PRODUCT_MATCHING.ALL_PRODUCT"
                                : "PRODUCT_MATCHING.ALL_PRODUCTS"
                            ) | translate
                        }}
                        <div
                            class="tw-text-base tw-text-caption-gray tw-text-[16px] tw-font-normal"
                            *ngIf="apiResponse"
                        >
                            {{ matchedProductsTotal }}
                            <ng-container
                                *ngIf="
                                    matchedProductsList?.length == 1;
                                    else multipleProducts
                                "
                            >
                                {{ "PRODUCT_MATCHING.PRODUCT" | translate }}
                            </ng-container>
                            <ng-template #multipleProducts>
                                {{ "PRODUCT_MATCHING.PRODUCTS" | translate }}
                            </ng-template>
                            {{ "PRODUCT_MATCHING.IN_THE_RESUILTS" | translate }}
                        </div>
                    </div>

                    <button
                        type="button"
                        class="sort-by tw-inline-flex tw-text-base tw-items-center tw-gap-x-1.5 tw-rounded-full tw-p-2 tw-w-[120px] tw-justify-center tw-font-semibold tw-text-gray-600 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-600 hover:tw-bg-gray-50"
                        id="menu-button"
                        aria-expanded="true"
                        aria-haspopup="true"
                        (click)="toggleFilter(!isFilterOpen)"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M4 4L9 12V18L15 21V12L20 4H4Z"
                                stroke="#7B7575"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>

                        {{ "PRODUCT_MATCHING.FILTER" | translate }}
                    </button>
                </div>

                <!-- filter starts desktop-->
                <div
                    #filterDropdown
                    class="filter-container tw-relative sort-by-container tw-w-full tw-rounded-lg tw-flex-col"
                >
                    <div
                        *ngIf="isFilterOpen"
                        class="tw-absolute tw-z-10 tw-mt-2 tw-right-[20px] tw-top-[-10px] tw-w-56 tw-origin-top-right tw-divide-y tw-divide-gray-100 tw-rounded-2xl tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabindex="-1"
                    >
                        <div class="tw-py-4 tw-px-5" role="none">
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['Provider']"
                                    (click)="
                                        onFilterProduct($event, 'Provider')
                                    "
                                />
                                <span class="tw-text-sm tw-font-semibold">
                                    {{
                                        "PRODUCT_MATCHING.PROVIDER" | translate
                                    }}
                                </span>
                            </div>
                            <div
                                class="tw-pl-6 tw-pb-4 tw-border-b-2 tw-border-placeholder-gray"
                            >
                                <div class="tw-py-1 tw-flex tw-items-center">
                                    <input
                                        type="checkbox"
                                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                        [checked]="checkboxStates['BANK']"
                                        (click)="
                                            onFilterProduct($event, 'BANK')
                                        "
                                    />
                                    <span class="tw-text-sm tw-font-semibold">
                                        {{
                                            "COMMON.BANKS" | translate
                                        }}</span
                                    >
                                </div>
                                <div class="tw-py-1 tw-flex tw-items-center">
                                    <input
                                        type="checkbox"
                                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                        [checked]="checkboxStates['DIGITAL BANK']"
                                        (click)="onFilterProduct($event, 'DIGITAL BANK')"
                                    />
                                    <span class="tw-text-sm tw-font-semibold"
                                        >Digital Banks</span
                                    >
                                </div>
                                <div class="tw-py-1 tw-flex tw-items-center">
                                    <input
                                        type="checkbox"
                                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                        [checked]="checkboxStates['P2P']"
                                        (click)="onFilterProduct($event, 'P2P')"
                                    />
                                    <span class="tw-text-sm tw-font-semibold"
                                        >P2P</span
                                    >
                                </div>
                                <div class="tw-py-1 tw-flex tw-items-center">
                                    <input
                                        type="checkbox"
                                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                        [checked]="checkboxStates['CGC']"
                                        (click)="onFilterProduct($event, 'CGC')"
                                    />
                                    <span class="tw-text-sm tw-font-semibold"
                                        >CGC</span
                                    >
                                </div>
                            </div>
                            <div
                                class="tw-pb-1 tw-flex tw-pt-4 tw-items-center"
                            >
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['Type']"
                                    (click)="onFilterProduct($event, 'Type')"
                                />
                                <span class="tw-text-sm tw-font-semibold">
                                    {{
                                        "PRODUCT_MATCHING.TYPE" | translate
                                    }}</span
                                >
                            </div>
                            <div class="tw-pl-6">
                                <div class="tw-py-1 tw-flex tw-items-center">
                                    <input
                                        type="checkbox"
                                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                        [checked]="checkboxStates['isIslamic']"
                                        (click)="
                                            onFilterProduct($event, 'isIslamic')
                                        "
                                    />
                                    <span class="tw-text-sm tw-font-semibold">
                                        {{
                                            "PRODUCT_MATCHING.ISLAMIC"
                                                | translate
                                        }}</span
                                    >
                                </div>
                                <div class="tw-py-1 tw-flex tw-items-center">
                                    <input
                                        type="checkbox"
                                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                        [checked]="
                                            checkboxStates['isConventional']
                                        "
                                        (click)="
                                            onFilterProduct(
                                                $event,
                                                'isConventional'
                                            )
                                        "
                                    />
                                    <span class="tw-text-sm tw-font-semibold">
                                        {{
                                            "PRODUCT_MATCHING.CONVENTIONAL"
                                                | translate
                                        }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- filter ends desktop-->
            </ng-container>
            <ng-container
                *ngIf="matchedProductsTotal == 0 && !noMatchedProducts"
            >
                <div
                    class="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-base tw-font-semibold tw-text-caption-gray tw-mb-4"
                >
                    {{ "NEW_APPLICATION.NO_FILTER_RESULT" | translate }}
                </div>
            </ng-container>
            <ng-container>
                <section
                    *ngIf="matchedProductsTotal > 0"
                    class="tw-flex tw-flex-col tw-gap-9 tw-p-6 tw-rounded-2xl tw-bg-white tw-border tw-mb-[30px] tw-border-gray-200 tw-max-w-[920px] tw-mx-auto"
                >
                    <!-- select BRP officer starts -->
                    <ng-container *ngIf="isBRPFlow">
                        <div
                            class="tw-flex tw-justify-between tw-items-center tw-font-['Figtree'] tw-text-[16px] tw-text-[#6C513A] tw-rounded-2xl tw-py-4 tw-px-5 tw-bg-[#EBBE943D]"
                        >
                            {{
                                "SELECT_BRANCH.PLEASE_SELECT_PREFERRED_BRANCH"
                                    | translate
                            }}
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-items-center tw-rounded-2xl tw-py-4 tw-px-5 tw-bg-[#95D1F33D]"
                        >
                            <div class="tw-flex tw-flex-col tw-gap-[2px]">
                                <div
                                    class="tw-text-[#003A70] tw-font-bold tw-text-lg"
                                >
                                    <ng-container
                                        *ngIf="
                                            selectedBrpBranches !== undefined &&
                                                selectedBrpBranches?.branchName;
                                            else selectBranchTxt
                                        "
                                    >
                                        {{ selectedBrpBranches?.branchName }}
                                        {{
                                            "SELECT_BRANCH.BRANCH_SELECTION"
                                                | translate
                                        }}
                                    </ng-container>
                                    <ng-template #selectBranchTxt>
                                        {{
                                            "SELECT_BRANCH.SELECT_A_BRANCH"
                                                | translate
                                        }}
                                    </ng-template>
                                </div>
                                <div
                                    class="tw-text-[#6D7A87] tw-font-semibold"
                                    *ngIf="selectedBrpBranches == undefined"
                                >
                                    <div>
                                        {{
                                            "SELECT_BRANCH.ONLY_ONE_BRANCH_IS_TO_BE_SELECTED"
                                                | translate
                                        }}
                                    </div>
                                </div>
                            </div>
                            <button
                                class="tw-p-[10px_30px_10px_30px] tw-rounded-full tw-bg-[#003A70] tw-text-lg tw-font-semibold tw-text-white"
                                (click)="onSelectBranchBRP()"
                            >
                                <ng-container
                                    *ngIf="
                                        selectedBrpBranches !== undefined &&
                                            selectedBrpBranches?.branchName;
                                        else selectBranchBtn
                                    "
                                >
                                    {{ "SELECT_BRANCH.CHANGE" | translate }}
                                </ng-container>
                                <ng-template #selectBranchBtn>
                                    {{ "SELECT_BRANCH.SELECT_NOW" | translate }}
                                </ng-template>
                            </button>
                        </div>
                    </ng-container>
                    <!-- select BRP officer ends -->

                    <div
                        *ngFor="
                            let productDetails of matchedProductsList;
                            let i = index
                        "
                        class="tw-flex tw-flex-col tw-gap-5 tw-rounded-3xl"
                    >
                        <ng-container
                            *ngIf="productDetails.prodNameList.length > 0"
                        >
                            <!-- header starts -->
                            <div
                                class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-7"
                            >
                                <div
                                    class="tw-w-[115px] tw-h-[81px] tw-rounded-[12px] tw-bg-white tw-overflow-hidden tw-border-[1px] tw-border-[#00000027]"
                                >
                                    <img
                                        class="tw-w-[50vw] md:tw-w-[100%] tw-h-[100%]"
                                        [src]="
                                            getImgUrl(productDetails.fiImage)
                                        "
                                        alt="Bank"
                                    />
                                </div>
                                <div
                                    class="tw-flex tw-flex-col tw-gap-1 tw-justify-center sm:tw-justify-start"
                                >
                                    <div
                                        class="tw-text-[16px] tw-text-[#6D7A87] tw-font-normal"
                                    >
                                        {{ productDetails.prodNameList.length }}
                                        <span
                                            *ngIf="
                                                productDetails.prodNameList
                                                    .length == 1
                                            "
                                        >
                                            {{
                                                "PRODUCT_MATCHING.PRODUCT"
                                                    | translate
                                            }}
                                            {{
                                                "PRODUCT_MATCHING.IS_AVAILABLE_FOR"
                                                    | translate
                                            }}:
                                        </span>
                                        <span
                                            *ngIf="
                                                productDetails.prodNameList
                                                    .length > 1
                                            "
                                        >
                                            {{
                                                "PRODUCT_MATCHING.PRODUCTS"
                                                    | translate
                                            }}
                                            {{
                                                "PRODUCT_MATCHING.ARE_AVAILABLE_FOR"
                                                    | translate
                                            }}:
                                        </span>
                                    </div>
                                    <div
                                        class="tw-flex tw-items-center tw-gap-2"
                                    >
                                        <span
                                            class="tw-px-3 tw-py-[6px] tw-rounded-full tw-text-white tw-left tw-top-2 tw-text-[13px]"
                                            [ngClass]="{
                                                'tw-bg-[#795CFC]':
                                                    productDetails
                                                        .prodNameList[0]
                                                        .prodCat == 'BANK',
                                                'tw-bg-blue-900':
                                                    productDetails
                                                        .prodNameList[0]
                                                        .prodCat == 'CGC',
                                                'tw-bg-orange-500':
                                                    productDetails
                                                        .prodNameList[0]
                                                        .prodCat == 'P2P',
                                                'tw-bg-blue-500':
                                                    productDetails
                                                        .prodNameList[0]
                                                        .prodCat == 'DIGITAL BANK'
                                            }"
                                        >
                                            {{
                                                productDetails.prodNameList[0]
                                                    .prodCat == "BANK"
                                                    ? (productDetails
                                                          .prodNameList[0]
                                                          .prodCat | titlecase)
                                                    : productDetails
                                                          .prodNameList[0]
                                                          .prodCat ||
                                                      productDetails
                                                          .prodNameList[0]
                                                          ?.productCategory
                                            }}
                                        </span>

                                        <span
                                            class="tw-text-[20px] tw-font-bold tw-text-[#003A70]"
                                        >
                                            {{ productDetails.fiNameEN }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- header ends -->

                            <!-- select branch starts -->
                            <ng-container
                                *ngIf="
                                    productDetails.branchActive == 'Y' &&
                                    !isBRP_CGC_Flow
                                "
                            >
                                <div
                                    class="tw-flex tw-justify-between tw-items-center tw-font-['Figtree'] tw-text-[16px] tw-text-[#6C513A] tw-rounded-2xl tw-py-4 tw-px-5 tw-bg-[#EBBE943D]"
                                >
                                    {{
                                        "SELECT_BRANCH.PLEASE_SELECT_PREFERRED_BRANCH"
                                            | translate
                                    }}
                                </div>
                                <div
                                    class="tw-flex tw-justify-between tw-items-center tw-rounded-2xl tw-py-4 tw-px-5 tw-bg-[#95D1F33D]"
                                >
                                    <div
                                        class="tw-flex tw-flex-col tw-gap-[2px]"
                                    >
                                        <div
                                            class="tw-text-[#003A70] tw-font-bold tw-text-lg"
                                        >
                                            <div
                                                *ngIf="
                                                    onBranchSelect(
                                                        productDetails?.fiId,
                                                        ''
                                                    ) as branchName;
                                                    else noBranchSelected
                                                "
                                            >
                                                {{ branchName }}
                                                {{
                                                    "SELECT_BRANCH.BRANCH_SELECTION"
                                                        | translate
                                                }}
                                            </div>
                                            <ng-template #noBranchSelected>
                                                {{
                                                    "SELECT_BRANCH.SELECT_A_BRANCH"
                                                        | translate
                                                }}
                                            </ng-template>
                                        </div>
                                        <div
                                            class="tw-text-[#6D7A87] tw-font-semibold"
                                        >
                                            <div
                                                *ngIf="
                                                    onBranchSelect(
                                                        productDetails?.fiId,
                                                        ''
                                                    ) as branchName;
                                                    else selectedProduct
                                                "
                                            >
                                                {{
                                                    "PRODUCT_MATCHING.PLEASE_SELECT_YOUR_PRODUCT"
                                                        | translate
                                                }}
                                            </div>
                                            <ng-template #selectedProduct>
                                                {{
                                                    "SELECT_BRANCH.ONLY_ONE_BRANCH_IS_TO_BE_SELECTED"
                                                        | translate
                                                }}
                                            </ng-template>
                                        </div>
                                    </div>
                                    <button
                                        class="tw-p-[10px_30px] tw-rounded-full tw-bg-[#003A70] tw-text-lg tw-font-semibold tw-text-white"
                                        (click)="showDialog(productDetails)"
                                    >
                                        <ng-container>
                                            {{
                                                (handleChangeBranch(
                                                    productDetails
                                                )
                                                    ? "SELECT_BRANCH.CHANGE"
                                                    : "SELECT_BRANCH.SELECT_NOW"
                                                ) | translate
                                            }}
                                        </ng-container>
                                    </button>
                                </div>
                            </ng-container>
                            <!-- select branch ends -->

                            <!-- product details starts -->
                            <div class="tw-flex tw-flex-col tw-gap-5">
                                <div
                                    *ngFor="
                                        let item of productDetails.prodNameList;
                                        let i = index
                                    "
                                    class="tw-flex tw-flex-col tw-gap-5 tw-py-4 sm:tw-px-4 tw-rounded-xl"
                                    [ngClass]="
                                        isProductSelected(item.prodCode) &&
                                        'tw-bg-[#95d1f357]'
                                    "
                                >
                                    <div
                                        class="tw-flex tw-gap-3 tw-items-center"
                                    >
                                        <input
                                            [attr.ga-event-id]="
                                                item.prodCode +
                                                '_product_selection_tick_product_match_click'
                                            "
                                            ga-event-category="Matched Products Page Button"
                                            [attr.ga-event-label]="
                                                item.prodCode +
                                                ' Product Selection Tick Button'
                                            "
                                            ga-track="track"
                                            type="checkbox"
                                            class="tw-w-5 tw-h-5 tw-cursor-pointer"
                                            [disabled]="
                                                !isProductSelected(
                                                    item.prodCode
                                                ) && limitExceeded
                                            "
                                            [checked]="
                                                isProductSelected(item.prodCode)
                                            "
                                            (change)="
                                                onSelectProduct(
                                                    $event,
                                                    item.prodCode,
                                                    productDetails,
                                                    item.prodCat
                                                )
                                            "
                                        />
                                        <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
                                            <div
                                                class="tw-font-bold tw-text-lg tw-text-[#003A70]"
                                            >
                                                {{ item.productName }}
                                            </div>
                                            <!-- Fast Transfer badge for Digital Bank products -->
                                            <!-- <span
                                                *ngIf="item.prodCat == 'DIGITAL BANK'"
                                                class="tw-px-2 tw-py-1 tw-font-bold tw-rounded-full tw-text-white tw-text-[10px] tw-bg-blue-400 tw-flex tw-items-center tw-gap-1"
                                            >
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="currentColor"/>
                                                </svg>
                                                Fast Transfer
                                            </span> -->
                                        </div>
                                    </div>
                                    <div
                                        class="tw-h-[1px] tw-bg-[#6d7a874f]"
                                    ></div>
                                    <div
                                        class="tw-flex md:tw-justify-between tw-flex-col md:tw-flex-row tw-gap-3"
                                    >
                                        <div
                                            class="tw-flex tw-flex-1 tw-justify-between tw-gap-3"
                                        >
                                            <div
                                                class="tw-flex tw-flex-col tw-gap-1 tw-flex-1 sm:tw-flex-none"
                                            >
                                                <div
                                                    class="tw-px-1 sm:tw-p-0 tw-text-[#6D7A87] tw-text-base tw-font-normal tw-bg-gray-300 md:tw-bg-transparent"
                                                >
                                                    {{
                                                        "COMMON.FINANCING"
                                                            | translate
                                                    }}
                                                </div>
                                                <div
                                                    class="tw-text-lg tw-font-bold tw-text-black !tw-text-[16px]"
                                                >
                                                    RM
                                                    {{
                                                        item.prodFinAmtMin
                                                            | number
                                                    }}
                                                    - RM
                                                    {{
                                                        item.prodFinAmtMax
                                                            | number
                                                    }}
                                                </div>
                                            </div>
                                            <div
                                                class="tw-flex tw-flex-col tw-gap-1 tw-flex-1 sm:tw-flex-none"
                                            >
                                                <div
                                                    class="tw-px-1 sm:tw-p-0 tw-text-[#6D7A87] tw-text-base tw-font-normal tw-bg-gray-300 md:tw-bg-transparent"
                                                >
                                                    {{
                                                        "PRODUCT_MATCHING.PROCESSING"
                                                            | translate
                                                    }}
                                                </div>
                                                <div
                                                    class="tw-text-lg tw-font-bold tw-text-black !tw-text-[16px]"
                                                >
                                                    {{ item.prodTat }}
                                                    <span>{{
                                                        "PRODUCT_MATCHING.WORKING_DAYS"
                                                            | translate
                                                    }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="tw-flex tw-flex-1 tw-justify-between tw-gap-3"
                                        >
                                            <div
                                                class="tw-flex tw-flex-col tw-gap-1 tw-flex-1 sm:tw-flex-none md:tw-ml-[100px]"
                                            >
                                                <div
                                                    class="tw-px-1 sm:tw-p-0 tw-text-[#6D7A87] tw-text-base tw-font-normal tw-bg-gray-300 md:tw-bg-transparent"
                                                >
                                                    {{
                                                        "PRODUCT_MATCHING.TENURE"
                                                            | translate
                                                    }}
                                                </div>
                                                <div
                                                    class="tw-text-lg tw-font-bold tw-text-black !tw-text-[16px]"
                                                >
                                                    {{ item.prodTenure }}
                                                    <span>{{
                                                        "PRODUCT_MATCHING.YEARS"
                                                            | translate
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div
                                                class="tw-flex tw-flex-col tw-gap-1 tw-flex-1 sm:tw-flex-none md:tw-mr-[50px]"
                                            >
                                                <div
                                                    class="tw-px-1 sm:tw-p-0 tw-text-[#6D7A87] tw-text-base tw-font-normal tw-bg-gray-300 md:tw-bg-transparent"
                                                >
                                                    {{
                                                        "PRODUCT_MATCHING.INTEREST"
                                                            | translate
                                                    }}
                                                </div>
                                                <div
                                                    class="tw-text-lg tw-font-bold tw-text-black !tw-text-[16px]"
                                                >
                                                    <span>{{
                                                        "PRODUCT_MATCHING.FROM"
                                                            | translate
                                                    }}</span>
                                                    {{ item.prodInterestRate }}
                                                    %
                                                    {{
                                                        "PRODUCT_MATCHING.PA"
                                                            | translate
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tw-mt-6" *ngIf="item.showMore">
                                        <div
                                            class="tw-font-medium tw-text-[#6D7A87] tw-text-[15px]"
                                            *ngIf="selectedLanguage == 'en'"
                                            [innerHtml]="item.productDescEng"
                                        >
                                            {{ item.productDescEng }}
                                        </div>
                                        <div
                                            class="tw-font-medium tw-text-[#6D7A87] tw-text-[15px]"
                                            *ngIf="selectedLanguage == 'bm'"
                                            [innerHtml]="item.productDescBm"
                                        >
                                            {{ item.productDescBm }}
                                        </div>
                                    </div>
                                    <div
                                        class="tw-flex"
                                        *ngIf="item.prodTag?.length"
                                    >
                                        <ng-container
                                            *ngFor="
                                                let tag of item.prodTag;
                                                let i = index
                                            "
                                        >
                                            <div
                                                class="tw-text-lg tw-font-semibold tw-py-[6px] tw-px-[18px] tw-rounded-full tw-text-[#003A70] tw-bg-[#95D1F3]"
                                            >
                                                {{ tag }}
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div
                                        class="tw-flex tw-items-center tw-cursor-pointer"
                                        (click)="item.showMore = !item.showMore"
                                    >
                                        <div
                                            class="tw-text-base tw-text-[#6D7A87]"
                                        >
                                            {{
                                                (item.showMore
                                                    ? "SELECT_BRANCH.SHOW_LESS"
                                                    : "SELECT_BRANCH.SHOW_MORE"
                                                ) | translate
                                            }}
                                        </div>
                                        <mat-icon>{{
                                            item.showMore
                                                ? "keyboard_arrow_up"
                                                : "keyboard_arrow_down"
                                        }}</mat-icon>
                                    </div>
                                </div>
                            </div>
                            <!-- product details ends -->
                        </ng-container>
                    </div>
                </section>
                <div
                    class="tw-max-w-[920px] tw-mx-auto"
                    *ngIf="!noMatchedProducts || matchedp2pProdTotal > 0"
                >
                    <mat-divider
                        *ngIf="!noMatchedProducts || matchedp2pProdTotal > 0"
                        class="dividerDirector"
                    ></mat-divider>
                    <ng-container *ngIf="isCGCFlow">
                        <span class="tw-text-gray-600 tw-text-[14px]" *ngIf="!noAvailableOptions">
                            {{
                                noMatchedProducts
                                    ? ("PRODUCT_MATCHING.IMPORTANT_NOTE_NO_MATCHED"
                                      | translate)
                                    : ("PRODUCT_MATCHING.IMPORTANT_NOTE_MATCHED"
                                      | translate)
                            }}
                        </span>
                        <app-product-selection-tab
                            *ngIf="!noAvailableOptions"
                            [isP2POnly]="noMatchedProducts"
                            [P2P_ProductsTotal]="P2P_ProductsTotal"
                            [bankProductsTotal]="bankProductsTotal"
                            [DigitalBanks_ProductsTotal]="DigitalBanks_ProductsTotal"
                        ></app-product-selection-tab>
                    </ng-container>
                    <div
                        [ngClass]="{
                            'lg:tw-mt-[-15px]': isCGCFlow && !noMatchedProducts,
                            'tw-mt-[-15px]': isCGCFlow && noMatchedProducts
                        }"
                        class="tw-hidden md:tw-flex tw-flex-wrap md:tw-flex-row md:tw-justify-end tw-justify-between tw-gap-[40px] tw-items-center md:tw-rounded-[80px] md:tw-py-[20px]"
                    >
                        <div
                            class="tw-order-1 tw-w-auto tw-flex tw-items-center"
                            *ngIf="!noMatchedProducts"
                        >
                            <button
                                ga-event-id="support_button_product_match_click"
                                ga-event-category="Matched Products Page Button"
                                ga-event-label="Support Button Click"
                                ga-track="track"
                                class="tw-text-[18px] tw-leading-[20px] tw-text-caption-gray md:tw-max-w-[175px] tw-w-full md:tw-pl-5 tw-text-center md:tw-text-left tw-font-[500]"
                                (click)="onClickSupport()"
                            >
                                {{ "PRODUCT_MATCHING.SUPPORT" | translate }}
                            </button>
                        </div>
                        <div class="tw-order-2 tw-w-auto">
                            <button
                                class="tw-text-[16px] tw-leading-[20px] tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-w-full tw-my-5 md:tw-my-0 md:tw-w-auto tw-px-[34px] tw-py-[14px]"
                                type="submit"
                                [attr.ga-event-id]="submitGAEventId"
                                [attr.ga-event-category]="submitGAEventCategory"
                                [attr.ga-event-label]="submitGAEventLabel"
                                ga-track="track"
                                [disabled]="disableSubmitBtn"
                                [ngClass]="
                                    disableSubmitBtn
                                        ? 'tw-bg-slate-300'
                                        : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                                "
                                (click)="
                                    noMatchedProducts
                                        ? onSubmitNoMatchedProduct()
                                        : onSubmitMatchedProduct()
                                "
                            >
                                {{
                                    "PRODUCT_MATCHING.CONFIRM_SELECTION"
                                        | translate
                                }}
                            </button>
                        </div>
                    </div>
                    <div
                        class="tw-flex md:tw-hidden tw-flex-col tw-gap-[10px] tw-items-center tw-py-2 tw-px-0"
                    >
                        <button
                            class="tw-text-[18px] tw-leading-[20px] tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-w-full tw-my-5 md:tw-my-0 md:tw-w-auto tw-py-[22px] tw-px-14"
                            type="submit"
                            [attr.ga-event-id]="submitGAEventId"
                            [attr.ga-event-category]="submitGAEventCategory"
                            [attr.ga-event-label]="submitGAEventLabel"
                            ga-track="track"
                            [disabled]="disableSubmitBtn"
                            [ngClass]="
                                disableSubmitBtn
                                    ? 'tw-bg-slate-300'
                                    : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                            "
                            (click)="
                                noMatchedProducts
                                    ? onSubmitNoMatchedProduct()
                                    : onSubmitMatchedProduct()
                            "
                        >
                            {{
                                "PRODUCT_MATCHING.CONFIRM_SELECTION" | translate
                            }}
                        </button>
                        <button
                            *ngIf="!noMatchedProducts"
                            ga-event-id="support_button_product_match_click"
                            ga-event-category="Matched Products Page Button"
                            ga-event-label="Support Button Click"
                            ga-track="track"
                            class="tw-text-[18px] tw-leading-[20px] tw-text-caption-gray md:tw-max-w-[175px] tw-w-full md:tw-pl-5 tw-text-center md:tw-text-left tw-font-[500]"
                            (click)="onClickSupport()"
                        >
                            {{ "PRODUCT_MATCHING.SUPPORT" | translate }}
                        </button>
                    </div>
                </div>
            </ng-container>

            <app-no-match
                *ngIf="isBRPNoMatchFlow || isCIDBNoMatchFlow"
                [caseId]="caseId"
                [isBRPNoMatchFlow]="isBRPNoMatchFlow"
            ></app-no-match>
        </div>
    </div>
</section>

<app-footer (click)="closeMegaMenuCondition()"></app-footer>
<app-loader [showLoader]="!apiResponse"></app-loader>
